import AimSettingContainer from '../../containers/aimSetting/aimSettingContainer';

export default function AimSetting() {
  return (
    <AimSettingContainer />
  );
}
